import { useQuery } from '@apollo/client';
import { QUERY_GET_USERS } from 'graphql/queries/users';
import { IUserDataToken } from 'utils/types';
import { IGetUsers, IUser } from 'views/backoffice/users/types';
import { QUERY_ME } from 'graphql/mutations/auth';

export const useCommentUsers = () => {
    const { data: usersData } = useQuery<IGetUsers>(QUERY_GET_USERS);
    const { data: curUserData } = useQuery(QUERY_ME);
    const user: IUserDataToken = curUserData?.me ? JSON.parse(curUserData.me) : null;

    const userList = usersData?.getSaasUsers ?? [];
    const usersById: Record<number, IUser> = userList.reduce((acc, el) => ({ ...acc, [el.id]: el }), {});
    const currentUser = usersData?.getSaasUsers.find(({ id }) => +id === +user.userId) as IUser;

    return { userList, usersById, currentUser };
};
